import { useQuery } from '@tanstack/react-query';

import type { FacilityScreenerSettingsEntry } from '@/types/crm-screener-api';

import { SCREENER_SETTINGS_PER_FACILITY_KEY } from './useFacilityScreenerSettings';

type ScreenerSettingValue = string | number | object;

export function useScreenerSetting<T extends ScreenerSettingValue = string>(
  settingName: string,
  facilityId: string
): T | undefined {
  const { data } = useQuery<FacilityScreenerSettingsEntry | undefined>({
    queryKey: [SCREENER_SETTINGS_PER_FACILITY_KEY, facilityId],
    queryFn: () => undefined,
    enabled: false
  });

  return data?.settings?.[settingName] as T | undefined;
}
